import styled from 'styled-components'

export const SavedVideosContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 70px;
  margin-left: 270px;
  background-color: ${props => (props.theme === true ? '#0f0f0f' : '#f9f9f9')};
  @media screen and (max-width: 767px) {
    width: 100%;
    margin-left: 0px;
    margin-top: 50px;
  }
`
export const SavedVideosHeader = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 130px;
  padding: 30px;
  background-color: ${props => (props.theme === true ? '#181818' : '#ebebeb')};
  @media screen and (max-width: 767px) {
    height: 80px;
    padding: 10px;
  }
`

export const SavedVideosIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 65px;
  width: 65px;
  border-radius: 50%;
  margin-right: 12px;
  background-color: ${props => (props.theme === true ? '#0f0f0f' : '#d7dfe9')};
  @media screen and (max-width: 767px) {
    height: 35px;
    width: 35px;
  }
`

export const SavedVideosIcon = styled.i`
  height: 23px;
  width: 23px;
  @media screen and (max-width: 767px) {
    height: 13px;
    width: 13px;
  }
`

export const SavedVideosPara = styled.h1`
  font-size: 28px;
  align-self: center;
  font-family: 'Roboto';
  font-weight: 800;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#424242')};
  @media screen and (max-width: 767px) {
    font-size: 18px;
  }
`

export const SavedVideosList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  width: 100%;
  background: transparent;
`

export const NoSavedView = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: ${props => (props.theme === true ? '#0f0f0f' : '#d7dfe9')};
`

export const NoSavedViewImg = styled.img`
  height: 300px;
  width: 300px;
`
export const NoSavedViewHeading = styled.h1`
  font-family: 'Roboto';
  font-size: 27px;
  text-align: center;
  margin: 22px;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#181818')};
`
export const NoSavedViewPara = styled.p`
  font-family: 'Roboto';
  font-size: 15px;
  text-align: center;
  color: ${props => (props.theme === true ? '#f4f4f4' : '#424242')};
`
